const APP_CONSTANTS = Object.freeze({
    DRAWERS: {
        HELP: 'help',
        CHATBOT: 'chatbot'
    }
});

export default APP_CONSTANTS;